import React, { useCallback, useEffect, useState } from 'react'
import { Box, Divider, Typography, useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import Latex from 'react-latex-next'

import { ALPHABETS, latexDelimiters, POLL_OPTIONS_COLORS } from '../../../utils/utilities'
import { useOnlineSessionsStore } from '../../../store/onlinesessions.store'
import TryAgainMessageBlock from '../../common/TryAgainMessageBlock'
import CustomSwitch from '../../common/CustomSwitch'
import CustomChip from '../../common/CustomChip'

const Poll = observer( ( { poll, index } ) => {

    const [showParticipants, setShowParticipants] = useState( false )

    const { palette, border, layout } = useTheme()

    return (
        <Box key={poll.id || poll.created_at} minWidth="0" width="100%" >
            {index !== 0 && <Divider sx={{ marginBottom: "10px" }} />}
            <Box borderRadius="5px" padding="5px">

                {/* <Box display="flex" gap="10px" flexWrap="wrap" marginY="10px">
                    <CustomChip value={`Posted at: ${formatDate( poll.created_at || poll.timestamp, { format: "DD-MM-YYYY hh:mm A" } )}`} />
                </Box> */}

                <Typography gutterBottom fontSize="14px" fontWeight={500}>
                    <Latex delimiters={latexDelimiters}>{poll.question}</Latex>
                </Typography>

                <Box display="flex" gap="10px" flexWrap="wrap" marginY="10px">
                    {Number.isInteger( poll.correct_answer ) && <Typography fontWeight="500" fontSize="14px" component="em" padding="5px 10px" borderRadius={layout.borderRadius} display="flex" alignItems="center" bgcolor={palette.success.main} color={palette.success.contrastText} >Correct Answer: {ALPHABETS.at( +( poll.correct_answer || 0 ) )}</Typography>}
                    <Box display="flex" padding="2px 10px" border={border[1]} borderRadius={layout.borderRadius} width="fit-content" bgcolor={palette.contentBg} flexWrap="wrap" gap="10px" alignItems="center">
                        <Typography variant='subtitle2' >
                            Show participants
                        </Typography>
                        <CustomSwitch size="small" color="secondary" checked={showParticipants} onChange={event => setShowParticipants( event.target.checked )} />
                    </Box>
                </Box>

                <Box display="grid" gap="10px" gridTemplateColumns={{ md: "1fr 1fr", xs: "1fr" }} marginTop="20px">
                    {poll.options?.map( ( option, i ) => (
                        <Box display="flex" borderRadius="5px" overflow="clip" alignItems="stretch" key={i}>

                            <Box flexShrink={0} width="40px" display="flex" alignItems="center" justifyContent="center" borderRight={border[1]} bgcolor={palette.contentBg}>
                                <Typography fontSize="14px" display="inline" >{ALPHABETS.at( i )}</Typography>
                            </Box>

                            <Box padding="5px" bgcolor={palette.contentBg} position="relative" width="100%">
                                <Typography gutterBottom position="relative" fontSize="14px" zIndex={2} display="block">
                                    <Latex delimiters={latexDelimiters}> {option}</Latex>
                                </Typography>

                                {!showParticipants && <Box width="100%" display="flex" flexDirection="column" alignItems="flex-start" gap="10px">
                                    <Typography color='textSecondary' position="relative" zIndex={2} display="block" fontSize="10px" variant='subtitle2'>{poll.votes?.[i]?.length > 1 ? `${poll.votes?.[i]?.length} Votes` : `${poll.votes?.[i]?.length || 0} Vote`} ({poll?.totalVotes > 0 ? `${Math.round( ( ( poll.votes?.[i]?.length || 0 ) * 100 ) / poll?.totalVotes )}%` : "0%"})</Typography>
                                    {/* VOTES INDICATOR */}
                                    <Box width="100%" overflow="clip" height="10px" bgcolor={palette.grey[600]} flexGrow={1} position="relative" padding="2px 5px" borderRadius="10px">
                                        <Box position="absolute" zIndex={1} sx={{ background: `${POLL_OPTIONS_COLORS[i]}` }} borderRadius="0 20px 20px 0" left="0" bottom="0" top="0" width={`${( ( poll.votes?.[i]?.length || 0 ) * 100 ) / poll?.totalVotes}%`} height="100%" ></Box>
                                    </Box>
                                </Box>}

                                {showParticipants && <Box borderRadius="10px" position="relative" width="100%">
                                    {poll.votes[i]?.length > 0 && <Box>
                                        {poll.votes[i]?.map( voter => (
                                            <CustomChip key={voter.user_id} textStyles={{ textTransform: "capitalize" }} value={voter.name} />
                                        ) )}
                                    </Box>}
                                    {poll.votes[i]?.length === 0 && <Typography color='textSecondary' position="relative" zIndex={2} display="block" fontSize="12px" textTransform="capitalize" variant='subtitle2'> No Votes!</Typography>}
                                </Box>}
                            </Box>
                        </Box>
                    ) )}
                </Box>

            </Box>
        </Box>
    )
} )

const OnlineSessionPolls = observer( () => {

    const { palette, layout } = useTheme()
    const { meeting_id } = useParams()

    const OnlineSessionsStore = useOnlineSessionsStore()

    const error = OnlineSessionsStore.getErrors.onlineSessionPolls

    const polls = OnlineSessionsStore.getPolls

    const fetchSessionPolls = useCallback( async () => {
        OnlineSessionsStore.fetchOnlineSessionPolls( meeting_id )
    }, [meeting_id, OnlineSessionsStore] )


    useEffect( () => {
        fetchSessionPolls()
    }, [fetchSessionPolls] )


    return (
        <Box padding="10px">
            {!error && polls.length > 0 && <Box display="flex" gap="10px" alignItems="center" flexDirection="column" flexWrap='wrap'>
                {polls?.map( ( poll, index ) => {
                    return (
                        <Poll key={poll.id || poll.created_at} poll={poll} index={index} />
                    )
                } )}
            </Box>}
            {!error && polls.length === 0 && <Box bgcolor={palette.contentBg} padding="20px" borderRadius={layout.borderRadius} >
                <Typography variant='subtitle2' component="p" textAlign="center">Polls were not conducted in this session.</Typography>
            </Box>}
            {error && <TryAgainMessageBlock parent='component' getData={fetchSessionPolls} code={error?.code} err={error?.message} />}
        </Box>

    )
} )

export default OnlineSessionPolls
